export const mapWorkingTimeDto = (dto) => ({
    id: dto.id,
    userId: dto.userId,
    validFrom: dto.validFrom,
    validUntil: dto.validUntil,
    weekday: dto.weekday,
    expectedHours: dto.expectedHours,
});

